import React from 'react';

import {
  useTranslation,
} from 'react-i18next';

import {
  useSelector,
} from 'react-redux';

import {
  ILanguageCountry,
} from '@noitada/axios-config/interfaces';

import {
  RootState,
} from '@noitada/redux-config';

import {
  languagesOption,
} from '@noitada/shared/arrays/App/lang-country.array';

import {
  Images,
} from '@noitada/shared/constants';

import {
} from '@noitada/shared/translations';

import {
  ButtonLanguageContainer,
  ButtonLanguageTitle,
  ButtonLanguageImage,
} from './styled';



export interface IProps {
  onPress?: any;
}



const ButtonLanguages: React.FC<IProps> = (props: IProps) => {
  const { t: translate } = useTranslation();


  const className: any = { ...props };


  const languageSelected = useSelector((state: RootState) => state.localities.language);
  const languageFiltered = languagesOption?.find((item: ILanguageCountry) => item?.languageIso === languageSelected);


  return (

    <ButtonLanguageContainer
      className={className?.className}
      onClick={props.onPress}>

      <ButtonLanguageTitle>
        {translate(languageFiltered?.label || '') || '-'}
      </ButtonLanguageTitle>


      <ButtonLanguageImage
        alt={translate(languageFiltered?.label || '') || '-'}
        src={languageFiltered?.flagImage || Images.placeholderAvatarCompany}
      />

    </ButtonLanguageContainer>

  );
};



export default ButtonLanguages;
